import { supabase } from "@/integrations/supabase/client";

/**
 * Determines whether the given workspace is the platform-wide
 * "superadmin" lens. When true, admin users should see ALL deals
 * across every workspace (read-through view); when false, queries
 * stay strictly scoped to that single workspace.
 */
export async function isSuperadminWorkspace(workspaceId: string | null): Promise<boolean> {
  if (!workspaceId) return false;
  const { data, error } = await supabase
    .from("workspaces")
    .select("is_superadmin")
    .eq("id", workspaceId)
    .maybeSingle();
  if (error || !data) return false;
  return Boolean((data as { is_superadmin?: boolean }).is_superadmin);
}
